import { gql, useMutation } from "@apollo/client";
import { MutationLoginUserArgs } from "../../__generated__/types";

const LOGIN_MUTATION = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      id
      firstName
      lastName
      aliasId
      email
      accountType
      phoneNumber
      address
      city
      state
      zipCode
      subscription {
        ... on DesignerSubscriptionWrapper {
          designerValue: value
        }
        ... on HomeOwnerSubscriptionWrapper {
          homeownerValue: value
        }
      }
      businessName
      businessWebsite
      workLocation
      emailVerified
      onboardingStatus
      paymentStatus
      membershipAutoRenew
      membershipBillingCycle
      membershipNextRenewalDate
      subscriptionDetails {
        planType
        billingCycle
        amount
        startDate
        endDate
        annualTermStartDate
        annualTermEndDate
        monthlyPlatformFeeNextBillingDate
        isActive
      }
    }
  }
`;

export const useLoginMutation = () => {
  const [login, { loading, error }] = useMutation(LOGIN_MUTATION);

  const loginUser = async (args: MutationLoginUserArgs) => {
    try {
      const result = await login({
        variables: args,
      });
      const userData = result?.data?.loginUser;
      
      // Extract subscription value from wrapper object (using aliases).
      // Important: never fall back to the raw wrapper object.
      const subscriptionWrapper = userData?.subscription as any;
      const resolvedSubscriptionValue =
        subscriptionWrapper && typeof subscriptionWrapper === "object"
          ? subscriptionWrapper.designerValue ||
            subscriptionWrapper.homeownerValue ||
            subscriptionWrapper.value ||
            subscriptionWrapper.tier ||
            null
          : typeof userData?.subscription === "string"
            ? userData.subscription
            : null;
      
      return {
        ...userData,
        subscription: resolvedSubscriptionValue, // Replace wrapper object with actual value
        emailVerified:
          userData?.emailVerified === "true"
            ? true
            : userData?.emailVerified === "false"
            ? false
            : userData.emailVerified,
      };
    } catch (err) {
      console.error("Login error:", err);
      throw err;
    }
  };

  return { loginUser, loading, error };
};
